/* tslint:disable */
/* eslint-disable */
/**
 * Tardek API Endpoints
 * This Is a documentation for T1 Tardek API Endpoints. <br />
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: info@bitweb.ee
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DeclarationValidationRequest
 */
export interface DeclarationValidationRequest {
    /**
     * Is opt-in
     * @type {boolean}
     * @memberof DeclarationValidationRequest
     */
    'isOptIn'?: boolean;
    /**
     * Phase ID
     * @type {string}
     * @memberof DeclarationValidationRequest
     */
    'phaseId'?: DeclarationValidationRequestPhaseIdEnum;
    /**
     * House consignment ID
     * @type {number}
     * @memberof DeclarationValidationRequest
     */
    'houseConsignmentId'?: number;
    /**
     * Consignment item ID
     * @type {number}
     * @memberof DeclarationValidationRequest
     */
    'consignmentItemId'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum DeclarationValidationRequestPhaseIdEnum {
    P5 = 'P5',
    P6 = 'P6'
}


